var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"box"},[_vm._v("🔔 "+_vm._s(_vm.billboard.content))]),_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-three-quarters"},[_c('Post')],1),_c('div',{staticClass:"column"},[_c('Sidebar')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }